import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  useHistory,
  useLocation,
  useParams,
} from 'react-router-dom/cjs/react-router-dom.min';
import Swal from 'sweetalert2';
import { alertError, alertSuccess } from '../../../components/Toast';
import { setData } from '../../../core/redux/app/Actions';
import { savePaymentTypes, saveTypeOS } from '../../../core/utils/budget';
import {
  deletedBudgetServiceOrder,
  saveBudgetServiceOrder,
} from '../../../core/utils/budgetServiceOrder';
import { loadFinancialEntriesByOS } from '../../../core/utils/financialEntry';
import { formatCurrency } from '../../../core/utils/format';
import {
  buildExternalUrl,
  buildWaMeUrl,
  openWhatsapp,
} from '../../../core/utils/whatsapp';
import { issueExternalLink } from '../../../core/utils/externalLinks';
import {
  OSStatusOptionEnum,
  sizeIdToOption,
} from '../../../screens/ModalBudget/utils/constants';
import { BUDGET_TABS } from '../../../screens/ModalBudget/utils/enum';
import ModalBudget from '../../../screens/OrderServiceBudget/ModalBudget/ModalBudget';
import { supabase } from '../../../supabaseClient';
import { useSyncBudgetVehicle } from '../../../core/hooks/useSyncBudgetVehicle';
import { compareValues } from '../../ModalClients/ModalClientsContainer';
import {
  applyPaintMarkup,
  calculateTotalValue,
  changeValueAeServiceFn,
  changeValueBodyshop,
  partDetails,
  partValues,
  resolvePrice,
  verifyTimesExist,
} from './utils/functions';

const ModalOrderServiceBudgetContainer = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const params = useParams();
  const id = location.pathname.split('/')[3];
  const isNew = params.id === '0';
  const user = useSelector((state) => state.app.user || {});
  const company = useSelector((state) => state.app.company || {});
  const reloadBudget = useSelector((state) => state.app.reloadBudget || false);
  const reloadPaymentOptions = useSelector(
    (state) => state.app.reloadPaymentOptions || false
  );
  const reloadConsultantOptions = useSelector(
    (state) => state.app.reloadConsultantOptions || false
  );
  const [values, setValues] = useState({
    entry_date: new Date().toISOString().split('T')[0],
    entry_hour: new Intl.DateTimeFormat('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).format(new Date()),
  });
  const [oldValues, setOldValues] = useState({});
  const [externalUrl, setExternalUrl] = useState(null);

  useEffect(() => {
    if (!values?.id) return undefined;
    let active = true;
    issueExternalLink('os', values.id).then(({ data }) => {
      if (active && data?.token) {
        setExternalUrl(buildExternalUrl('os', data.token));
      }
    });
    return () => {
      active = false;
    };
  }, [values?.id]);

  const [responsible, setResponsible] = useState([]);
  const [budget, setBudget] = useState(1);
  const [addBudget, setAddBudget] = useState(null);
  const [open, setOpen] = useState(false);
  const [hasCreated, setHasCreated] = useState(false);
  const [hasCreatedConsultant, setSetHasCreatedConsultant] = useState(false);
  const [hasCreatedTypeOS, setHasCreatedTypeOS] = useState(false);
  const [reloadConsultants, setReloadConsultants] = useState(false);
  const [reloadTypeOS, setReloadTypeOS] = useState(false);
  const [client, setClient] = useState([]);
  const [clientLoading, setClientLoading] = useState(true);
  const [vehicle, setVehicle] = useState([]);
  const [vehicleLoading, setVehicleLoading] = useState(true);
  const [bodyshopService, setBodyshopService] = useState([]);
  const [bodyshopServiceVersion, setBodyshopServiceVersion] = useState(0);
  const [aeService, setAeService] = useState([]);
  const [serviceType, setServiceType] = useState([]);
  const [parts, setParts] = useState([]);
  const [part, setPart] = useState({});
  const [reload, setReload] = useState(false);
  const [hvTable, setHvTable] = useState([]);
  const [info, setInfo] = useState([]);
  const [aeInfo, setAeInfo] = useState([]);
  const [isntLinearHour, setIsntLinearHour] = useState(false);
  const [valuesBasedOnSize, setValuesBasedOnSize] = useState([]);
  const [hasInitialLength, setHasInitialLength] = useState(false);
  const [initialClientLength, setInitialClientLength] = useState(0);
  const [initialVehicleLength, setInitialVehicleLength] = useState(0);
  const [reloadPrint, setReloadPrint] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [printCompany, setPrintCompany] = useState({});
  const [clientCreationContext, setClientCreationContext] = useState(null);

  const changeValue = (field, data, value, edited = false) => {
    setReloadPrint((reload) => !reload);
    setBodyshopService((array) =>
      changeValueBodyshop({ array, field, data, value, edited })
    );
  };

  const changePartsDetail = (field, data, value) => {
    setReloadPrint((reload) => !reload);
    setParts((array) => partDetails({ array, field, data, value, part }));
  };

  const changePartsValue = (field, data, value) => {
    setReloadPrint((reload) => !reload);
    setParts((array) => partValues({ array, field, data, value }));
  };

  const changeValueAeService = (field, data, value, edited = false) => {
    setReloadPrint((reload) => !reload);
    setAeService((array) =>
      changeValueAeServiceFn({ array, field, data, value, edited })
    );
  };

  useSyncBudgetVehicle({ values, setValues, reload });

  useEffect(() => {
    if (open && !hasInitialLength && client && vehicle) {
      setInitialClientLength(client.length);
      setInitialVehicleLength(vehicle.length);
      setHasInitialLength((hasInitialLength) => hasInitialLength);
    }
  }, [open, client, vehicle]);

  useEffect(() => {
    if (
      !open &&
      vehicle.length > initialVehicleLength &&
      initialVehicleLength !== 0
    ) {
      const sortedVehicle = vehicle.sort(
        (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
      );
      const mostRecentVehicle = sortedVehicle[0];

      setValues((prevValues) => ({
        ...prevValues,
        vehicle: mostRecentVehicle,
      }));
    }
  }, [open, vehicle, initialVehicleLength]);

  useEffect(() => {
    if (
      !open &&
      (client.length > initialClientLength) & (initialClientLength !== 0) &&
      clientCreationContext
    ) {
      const mostRecentClient = client.reduce((prev, current) => {
        const prevDate = new Date(prev.date).getTime();
        const currentDate = new Date(current.date).getTime();
        return currentDate > prevDate ? current : prev;
      });

      setValues((prevValues) => ({
        ...prevValues,
        [clientCreationContext]: mostRecentClient,
      }));
      setClientCreationContext(null);
    }
  }, [open, client, initialClientLength, clientCreationContext]);

  const decidePriceBasedOnSize = async (values, info) => {
    if (values?.size) {
      let chosenSize = values?.size;

      const filteredData = info.map((item) => {
        if (chosenSize.id == 2 || chosenSize.id == '2') {
          return {
            value: item.hasOwnProperty('p_value') ? item.p_value : null,
            time: item.hasOwnProperty('p_time') ? item.p_time : null,
            title: item.title,
            id: item.id,
          };
        } else if (chosenSize.id == 3 || chosenSize.id == '3') {
          return {
            value: item.hasOwnProperty('m_value') ? item.m_value : null,
            time: item.hasOwnProperty('m_time') ? item.m_time : null,
            title: item.title,
            id: item.id,
          };
        } else if (chosenSize.id == 4 || chosenSize.id == '4') {
          return {
            value: item.hasOwnProperty('g_value') ? item.g_value : null,
            time: item.hasOwnProperty('g_time') ? item.g_time : null,
            title: item.title,
            id: item.id,
          };
        } else {
          return {};
        }
      });

      // const newValuesBasedOnSize = filteredData.filter((item) =>
      //   Object.values(item).every((value) => value !== null)
      // );
      setValuesBasedOnSize(filteredData);
    }
  };

  useEffect(() => {
    decidePriceBasedOnSize(values, info);
  }, [values, info]);

  // Nota:
  // Esse useEffect abaixo é responsável pelas operações envolvendo as trocas entre hora linear,
  // hora tabela, adicional sobre pintura e também valores baseados no tamanho.
  useEffect(() => {
    if (values?.percentage === undefined) {
      values.percentage = 0;
    }

    setBodyshopService((prevService) => {
      if (prevService) {
        return prevService.map((item) => {
          let updatedItem = { ...item };
          let parsedTypes;
          let tableValue;
          let matchingParsedType;
          let matchingParsedTypeValue;
          let matchingTableService;

          if (updatedItem.time === undefined) {
            updatedItem.time = '00:00';
          }

          const formatValue = (value) =>
            value && value.length >= 2 && value.substr(0, 2) === 'R$'
              ? value.substr(2)
              : value;

          const paintService =
            updatedItem?.title &&
            updatedItem?.title?.toLowerCase().includes('pintura');

          // Se FOR hora linear *ou seja, se o valor NÃO vier de alguma tabela valor-hora*
          if (
            !isntLinearHour &&
            values?.price !== undefined
            // &&
            // (values.price !== prevValues.price ||
            //   values.percentage !== prevValues.percentage)
          ) {
            const sanitizedUnitaryValue =
              values?.price && typeof values?.price === 'string'
                ? values?.price.length >= 2 &&
                  values?.price.substr(0, 2) === 'R$'
                  ? values?.price.substr(2).replace(',', '.')
                  : values?.price.replace(',', '.')
                : '';

            if (prevService) {
              if (
                paintService &&
                values?.percentage !== undefined &&
                values?.percentage !== 0
              ) {
                updatedItem.unitaryValue =
                  parseFloat(sanitizedUnitaryValue) +
                  (parseFloat(sanitizedUnitaryValue) * values?.percentage) /
                    100;
                updatedItem.time = updatedItem.time;
              } else {
                updatedItem.unitaryValue = item.editedPrice
                  ? item.unitaryValue
                  : sanitizedUnitaryValue;
                updatedItem.time = item.editedHour
                  ? item.time
                  : updatedItem.time;
              }
            } else {
              updatedItem.unitaryValue = item.editedPrice
                ? item.unitaryValue
                : updatedItem.unitaryValue;
              updatedItem.time = item.editedHour ? item.time : updatedItem.time;
            }
          } else {
            if (
              (values?.price === undefined ||
                values?.price === null ||
                values?.price === 0) &&
              (prevService.unitaryValue === undefined ||
                prevService.unitaryValue === null ||
                prevService.unitaryValue === 0)
            ) {
              updatedItem.unitaryValue = item.editedPrice
                ? item.unitaryValue
                : prevService.unitaryValue;
            } else {
              updatedItem.unitaryValue = item.editedPrice
                ? item.unitaryValue
                : updatedItem.unitaryValue;
            }
            updatedItem.time = item.editedHour ? item.time : updatedItem.time;
          }

          // Se não for hora linear *ou seja, se o valor vier de alguma tabela valor-hora*
          if (
            isntLinearHour &&
            values?.price !== undefined
            // values?.percentage !== prevvalues?.percentage
          ) {
            if (prevService) {
              tableValue = values?.price;

              if (
                typeof tableValue === 'string' &&
                tableValue.length <= 4 &&
                /^\d+$/.test(tableValue)
              ) {
                tableValue = hvTable.find(
                  (item) => item.id === Number(tableValue)
                );
              }

              parsedTypes =
                tableValue && tableValue.service_types
                  ? JSON.parse(tableValue.service_types)
                  : [];

              matchingTableService =
                updatedItem?.title &&
                updatedItem?.title?.toLowerCase().includes('pintura')
                  ? updatedItem
                  : false;

              matchingParsedType = parsedTypes.find(
                (parsedItem) => parsedItem.id === item.service_type
              );

              matchingParsedTypeValue = formatValue(matchingParsedType?.value);

              if (matchingTableService && values?.percentage !== undefined) {
                if (paintService) {
                  updatedItem.unitaryValue =
                    parseFloat(matchingParsedTypeValue) +
                    (parseFloat(matchingParsedTypeValue) * values?.percentage) /
                      100;
                } else {
                  updatedItem.unitaryValue = item.editedPrice
                    ? item.unitaryValue
                    : parseFloat(matchingParsedTypeValue);
                }
              } else {
                const loadedUnitaryValue = (
                  matchingParsedTypeValue ?? ''
                ).replace(',', '.');
                updatedItem.unitaryValue = item.editedPrice
                  ? item.unitaryValue
                  : parseFloat(loadedUnitaryValue);
              }
            } else {
              updatedItem.unitaryValue = item.editedPrice
                ? item.unitaryValue
                : updatedItem.unitaryValue;
            }
            updatedItem.unitaryValue = item.editedPrice
              ? item.unitaryValue
              : updatedItem.unitaryValue;
            updatedItem.time = item.editedHour ? item.time : updatedItem.time;
          }

          // Caso haja algum item com a classificação de serviço como PINTURA, pra aplicar
          // o adicional sobre pintura. Além disso, também adiciona o valor e tempo baseado no tamanho escolhido.
          if (
            values?.price === undefined ||
            values?.price == 0 ||
            values?.price == 'R$'
          ) {
            if (prevService) {
              if (paintService) {
                if (valuesBasedOnSize.length > 0) {
                  for (let i = 0; i < valuesBasedOnSize.length; i++) {
                    if (
                      valuesBasedOnSize[i].value >= 0 &&
                      valuesBasedOnSize[i].time !== 0 &&
                      valuesBasedOnSize[i].title === updatedItem.title
                    ) {
                      if (item.editedPrice) {
                        updatedItem.unitaryValue = item.unitaryValue;
                      } else {
                        updatedItem.unitaryValue = applyPaintMarkup(
                          valuesBasedOnSize[i].value,
                          values?.percentage
                        );
                      }
                      updatedItem.time = item.editedHour
                        ? item.time
                        : valuesBasedOnSize[i].time;
                    } else {
                      updatedItem.unitaryValue = item.editedPrice
                        ? item.unitaryValue
                        : updatedItem.unitaryValue;
                      updatedItem.time = item.editedHour
                        ? item.time
                        : updatedItem.time;
                    }
                  }
                } else {
                  updatedItem.unitaryValue = item.editedPrice
                    ? item.unitaryValue
                    : updatedItem.unitaryValue;
                  updatedItem.time = item.editedHour
                    ? item.time
                    : updatedItem.time;
                }
              } else {
                for (let i = 0; i < valuesBasedOnSize.length; i++) {
                  if (
                    valuesBasedOnSize[i].value >= 0 &&
                    valuesBasedOnSize[i].time !== 0 &&
                    valuesBasedOnSize[i].title === updatedItem.title
                  ) {
                    updatedItem.unitaryValue = item.editedPrice
                      ? item.unitaryValue
                      : valuesBasedOnSize[i].value;
                    updatedItem.time = item.editedHour
                      ? item.time
                      : valuesBasedOnSize[i].time;
                  } else {
                    updatedItem.unitaryValue = item.editedPrice
                      ? item.unitaryValue
                      : updatedItem.unitaryValue;
                    updatedItem.time = item.editedHour
                      ? item.time
                      : updatedItem.time;
                  }
                }
              }
            }
          } else {
            for (let i = 0; i < valuesBasedOnSize.length; i++) {
              if (
                valuesBasedOnSize[i].value >= 0 &&
                valuesBasedOnSize[i].time !== 0 &&
                valuesBasedOnSize[i].title === updatedItem.title
              ) {
                // updatedItem.unitaryValue = valuesBasedOnSize[i].value
                updatedItem.time = item.editedHour
                  ? item.time
                  : valuesBasedOnSize[i].time;
              } else {
                updatedItem.unitaryValue = item.editedPrice
                  ? item.unitaryValue
                  : updatedItem.unitaryValue;
                updatedItem.time = item.editedHour
                  ? item.time
                  : updatedItem.time;
              }
            }
          }

          updatedItem.value = calculateTotalValue(
            updatedItem.time,
            typeof updatedItem?.unitaryValue === 'string'
              ? updatedItem?.unitaryValue?.replace(',', '.')
              : updatedItem.unitaryValue
          );

          return updatedItem;
        });
      }
    }, []);
  }, [values?.price, values?.percentage, valuesBasedOnSize, isntLinearHour, hvTable, bodyshopServiceVersion]);

  useEffect(() => {
    loadHourlyValue();
  }, [company]);
  useEffect(() => {
    if (id !== '0') {
      loadData();
    }
  }, [id]);

  useEffect(() => {
    const path = location.pathname.split('/')[1];
    dispatch(
      setData({ [`compareValues_${path}`]: compareValues(oldValues, values) })
    );
  }, [values, oldValues]);

  useEffect(() => {
    loadClient();
  }, [company.id, reload]);

  // Recarrega dados quando o cliente é editado
  useEffect(() => {
    const reloadClientData = async () => {
      // Recarrega a lista de clientes
      await loadClient();

      // Atualiza os dados do cliente selecionado
      if (values?.client) {
        const clientId = values.client.value || values.client;

        // Busca os dados atualizados do cliente
        const { data: clientData, error } = await supabase
          .from('Client')
          .select('*, Vehicle(responsible, *), Origin(id, *)')
          .eq('id', clientId)
          .is('deleted_at', null)
          .single();

        if (!error && clientData) {
          // Atualiza apenas com os campos necessários, evitando objetos problemáticos
          setValues(prev => ({
            ...prev,
            client: {
              value: clientData.id,
              label: clientData.name,
              // Campos essenciais do cliente
              id: clientData.id,
              name: clientData.name,
              cellphone: clientData.cellphone,
              telephone: clientData.telephone,
              email: clientData.email,
              cpf: clientData.cpf,
              cnpj: clientData.cnpj,
              rg: clientData.rg,
              birthday: clientData.birthday,
              cep: clientData.cep,
              street: clientData.street,
              number: clientData.number,
              complement: clientData.complement,
              neighborhood: clientData.neighborhood,
              city: clientData.city,
              state: clientData.state,
              countrie: clientData.countrie,
              observation: clientData.observation,
              person: clientData.person,
              origin: clientData.origin,
              Vehicle: clientData.Vehicle,
              Origin: clientData.Origin
            },
            client_name: clientData.name
          }));
        }
      }
    };

    reloadClientData();
  }, [reloadBudget]);

  useEffect(() => {
    loadResponsible();
  }, [company.id]);

  useEffect(() => {
    loadServices();
    loadAestheticServices();
  }, [company]);

  const loadServices = async () => {
    let { data, error } = await supabase
      .from('Services')
      .select('*')
      .eq('id_company', company.id)
      .is('deleted_at', null);
    if (!error) {
      getServiceTable(data);
    }
  };

  const loadAestheticServices = async () => {
    let { data, error } = await supabase
      .from('AestheticServices')
      .select('*')
      .eq('id_company', company.id)
      .is('deleted_at', null);
    if (!error) {
      getAestheticServiceTable(data);
    }
  };

  const getServiceTable = async (data) => {
    const dataFormatter =
      values?.price && values?.price.service_types
        ? JSON.parse(values?.price.service_types)
        : [];

    const newData = data.map((item) =>
      item.service_type === budget
        ? {
            ...item,
            unitaryValue: dataFormatter?.find((item) => item.id === budget)
              ?.value,
          }
        : item
    );

    setInfo(newData);
  };

  const getAestheticServiceTable = async (data) => {
    const dataFormatter =
      values?.price && values?.price.service_types
        ? JSON.parse(values?.price.service_types)
        : [];

    const newData = data.map((item) =>
      item.service_type === budget
        ? {
            ...item,
            unitaryValue: dataFormatter?.find((item) => item.id === budget)
              ?.value,
          }
        : item
    );

    setAeInfo(newData);
  };

  useEffect(() => {
    getServiceTable(info);
    getAestheticServiceTable(aeInfo);
  }, []);

  const loadHourlyValue = async () => {
    let { data, error } = await supabase
      .from('HourlyValue')
      .select('*')
      .eq('id_company', company.id)
      .is('deleted_at', null);
    if (!error) {
      setHvTable(
        data.map((item) => ({ ...item, label: item.title, value: item.id }))
      );
    }
  };

  const showBudgetItems = (id, budget = false, items) => {
    if (budget) {
      const budgetFilter = addBudget || [];
      setAddBudget(
        budgetFilter.filter((item) => item.id === id).length > 0
          ? budgetFilter.filter((item) => item.id !== id)
          : budgetFilter.concat(items)
      );
    } else {
      setBudget(id);
    }
  };

  const loadData = async () => {
    let { data, error } = await supabase
      .from('BudgetServiceOrder')
      .select(
        `
        *,
        Vehicle(responsible, *),
        ImportedBudgetOS(budget_id)
        `
      )
      .eq('id', id)
      .is('deleted_at', null);
    if (!error) {
      const valuesSize = () => sizeIdToOption(data?.[0]?.size);
      setValues({
        ...data[0],
        os_type: JSON.parse(data[0]?.os_type),
        entry_checklist: data[0]?.entry_checklist
          ? JSON.parse(data[0]?.entry_checklist)
          : null,
        size: valuesSize(),
        id_consultant: data[0]?.id_consultant,
        bodyshop_discount: data[0]?.bodyshop_discount || 0,
        aesthetics_discount: data[0]?.aesthetics_discount || 0,
        parts_discount: data[0]?.parts_discount || 0,
      });

      setIsntLinearHour(data[0]?.hour);
      setOldValues(data[0]);
      setBodyshopService(JSON.parse(data[0]?.service) || []);
      setAeService(
        JSON.parse(data[0]?.ae_service)?.map((item) => ({
          ...item,
          unitaryValue: item.unitaryValue || item.p_value,
          quantity: item.quantity || 1,
        })) || []
      );
      setParts(JSON.parse(data[0]?.parts) || []);
    }
  };

  useEffect(() => {
    if (id !== '0') {
      loadData();
    } else if (id === '0') {
      loadCompany();
      setValues((values) => ({
        ...values,
        observation: company.budgetNote,
        percentage: values?.percentage ? values?.percentage : 0,
        size: values?.size?.value
          ? values?.size
          : { id: 3, value: 'M', label: 'M' },
        status: values?.status?.values
          ? values?.status
          : {
              id: OSStatusOptionEnum.ABERTA,
              value: 'Aberta',
              label: 'Aberta',
              color: '#6eb6ff',
            },
      }));
      setOldValues((values) => ({
        ...values,
        observation: company.budgetNote,
        percentage: values?.percentage ? values?.percentage : 0,
        size: values?.size?.value
          ? values?.size
          : { id: 3, value: 'M', label: 'M' },
        status: values?.status?.values
          ? values?.status
          : {
              id: OSStatusOptionEnum.ABERTA,
              value: 'Aberta',
              label: 'Aberta',
              color: '#6eb6ff',
            },
      }));
    }
  }, [id, company]);

  useEffect(() => {
    loadVehicleNoClient();
  }, [values?.client?.value || values?.client, reload]);

  const addedParts =
    values?.parts !== undefined ? JSON.parse(values?.parts) : undefined;

  const addedServices = values?.service
    ? JSON.parse(values?.service)
    : undefined;

  const closeModal = () => {
    if (compareValues(oldValues, values)) {
      Swal.fire({
        title: 'Deseja sair sem salvar?',
        showCancelButton: true,
        showConfirmButton: false,
        showDenyButton: true,
        icon: 'warning',
        text: 'Ao sair, seus dados seram descartados.',
        denyButtonText: `Descartar`,
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isDenied) {
          history.push('/order-services');
        }
      });
    } else {
      history.push('/order-services');
    }
  };

  const loadResponsible = async () => {
    // Paginação para buscar todos os clientes
    let allData = [];
    const pageSize = 1000;
    let page = 0;
    let hasMore = true;

    while (hasMore) {
      const from = page * pageSize;
      const to = from + pageSize - 1;

      let { data: pageData, error } = await supabase
        .from('Client')
        .select('*')
        .eq('id_company', company.id)
        .is('deleted_at', null)
        .range(from, to)
        .order('name', { ascending: true });

      if (error) break;

      if (pageData && pageData.length > 0) {
        allData = [...allData, ...pageData];
      }

      hasMore = pageData && pageData.length === pageSize;
      page++;
    }

    setResponsible(
      allData.map((item) => ({
        label: item.name,
        value: item.id,
        cellphone: item.cellphone,
      }))
    );
  };

  const loadClient = async () => {
    setClientLoading(true);
    try {
      // Paginação para buscar todos os clientes
      let allData = [];
      const pageSize = 1000;
      let page = 0;
      let hasMore = true;

      while (hasMore) {
        const from = page * pageSize;
        const to = from + pageSize - 1;

        // Projeta só os campos que o setClient.map abaixo consome — sem JOINs
        // Vehicle/Origin descartados, sem `*`. Reduz drasticamente o payload em
        // empresas com muitos clientes/veículos. Detalhes completos do cliente
        // são buscados sob demanda em reloadClientData (.eq('id', id).single()).
        let { data: pageData, error } = await supabase
          .from('Client')
          .select('id, name, created_at, cnpj, cpf, telephone, cellphone')
          .eq('id_company', company.id)
          .is('deleted_at', null)
          .range(from, to)
          .order('name', { ascending: true });

        if (error) break;

        if (pageData && pageData.length > 0) {
          allData = [...allData, ...pageData];
        }

        hasMore = pageData && pageData.length === pageSize;
        page++;
      }

      setClient(
        allData.map((item) => ({
          label: item.name,
          value: item.id,
          date: item.created_at,
          cnpj: item.cnpj,
          cpf: item.cpf,
          telephone: item.telephone,
          cellphone: item.cellphone,
        }))
      );
    } finally {
      setClientLoading(false);
    }
  };

  const loadVehicleNoClient = async () => {
    setVehicleLoading(true);
    try {
      let allData = [];
      let from = 0;
      const pageSize = 1000;
      let hasMore = true;

      while (hasMore) {
        // Projeta só o que o setVehicle.map abaixo consome.
        const { data, error } = await supabase
          .from('Vehicle')
          .select('id, plate, model, created_at')
          .is('deleted_at', null)
          .eq('company', company.id)
          .range(from, from + pageSize - 1);

        if (error) {
          console.error('Error loading vehicles:', error);
          break;
        }

        if (data && data.length > 0) {
          allData = [...allData, ...data];
          from += pageSize;
          hasMore = data.length === pageSize;
        } else {
          hasMore = false;
        }
      }

      setVehicle(
        allData.map((item) => ({
          label: `${item.plate} / (${item.model})`,
          value: item.id,
          date: item.created_at,
        }))
      );
    } finally {
      setVehicleLoading(false);
    }
  };

  useEffect(() => {
    loadCompany();
  }, []);

  const loadCompany = async () => {
    let { data, error } = await supabase
      .from('Company')
      .select('*')
      .eq('id', company.id)
      .is('deleted_at', null);

    if (!error) {
      setPrintCompany(data[0]);
    } else {
      console.log(error);
    }
  };

  const generateBudgetCode = async (companyId) => {
    const today = new Date();
    const year = today.getFullYear().toString().slice(-2);
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const { data: existingBudgets, error } = await supabase
      .from('BudgetServiceOrder')
      .select('id')
      .is('deleted_at', null)
      .eq('id_company', companyId)
      .gte('created_at', `${dateWithoutTimezone(today).slice(0, 10)}T00:00:00`)
      .lte('created_at', `${dateWithoutTimezone(today).slice(0, 10)}T23:59:59`);
    const numberOfBudgets =
      existingBudgets && existingBudgets.length > 0
        ? existingBudgets.length
        : 0;
    const codeNumber = String(numberOfBudgets).padStart(2, '0');

    return `S${year}${month}${day}${codeNumber}`;
  };
  const onSave = async (functionPrint = undefined, skipRedirect = false) => {
    const newBudgetCode = await generateBudgetCode(company.id);

    try {
      const {
        Vehicle,
        newlyImportedBudgets,
        ImportedBudgetOS,
        ...valuesWithoutVehicle
      } = values;

      if (values && !values.client) {
        alertError('Cliente é obrigatório');
        return;
      }

      if (values && !values.vehicle) {
        alertError('Veículo é obrigatório');
        return;
      }

      if (values && !values.size) {
        alertError('Tamanho é obrigatório');
        return;
      }

      if (values && !values.status) {
        alertError('Status é obrigatório');
        return;
      }

      if (values && !values.delivery_date) {
        alertError('Previsão de entrega é obrigatória');
        return;
      }

      if (!verifyTimesExist(bodyshopService)) {
        setBudget(BUDGET_TABS.BODYSHOP);
        alertError('Campo de horas com valor zerado');
        return;
      }

      // Buscar dados de assinatura atuais do banco para preservá-los
      let existingSignatureData = {};
      if (values?.id) {
        const { data: currentData, error: fetchError } = await supabase
          .from('BudgetServiceOrder')
          .select('client_authorization, client_signature, signature_date')
          .eq('id', values.id)
          .single();

        if (!fetchError && currentData) {
          existingSignatureData = {
            client_authorization: currentData.client_authorization,
            client_signature: currentData.client_signature,
            signature_date: currentData.signature_date,
          };
        }
      }

      // Criar consultor se for novo (value = '0' ou string) antes de salvar a ordem de serviço
      let consultantId = values?.id_consultant?.value || values?.id_consultant;

      if (
        values?.id_consultant &&
        (values.id_consultant.value === '0' ||
          values.id_consultant.value === 0 ||
          (typeof values.id_consultant === 'object' &&
            typeof values.id_consultant.value === 'string' &&
            values.id_consultant.value === '0'))
      ) {
        try {
          const { data: consultantData, error: consultantError } =
            await supabase
              .from('CompanyConsultant')
              .insert([
                {
                  name: values.id_consultant.label,
                  company_id: company.id,
                },
              ])
              .select('*');

          if (!consultantError && consultantData?.[0]) {
            consultantId = consultantData[0].id;
            alertSuccess('Consultor criado com sucesso!');
            setReloadConsultants((prev) => !prev);
            // Atualizar o values para usar o ID real do consultor criado
            setValues((prev) => ({
              ...prev,
              id_consultant: consultantId,
            }));
          }
        } catch (error) {
          alertError('Erro ao criar consultor');
          return;
        }
      }

      const body = {
        ...valuesWithoutVehicle,
        created_at: dateWithoutTimezone(new Date()),
        code: values && values.code ? values.code : newBudgetCode,
        payment:
          (values && values.payment && values.payment.id) || values.payment,
        size: (values && values.size && values.size.id) || values.size,
        status: (values && values.status && values.status.id) || values.status,
        hour: (values && values?.hour) || values?.hour,
        price: resolvePrice(values),
        client:
          (values && values.client && values.client.value) || values.client,
        client_name:
          (values && values.client && values.client.label) ||
          values.client_name,
        id_company: company.id,
        vehicle:
          (values && values.vehicle && values.vehicle.value) || values.vehicle,
        vehicle_name:
          (values && values.vehicle && values.vehicle.label) ||
          values.vehicle_name,
        service: JSON.stringify(
          bodyshopService.map((item, index) => ({ ...item, id: index })) || []
        ),
        parts: JSON.stringify(
          parts.map((item, index) => ({ ...item, id: index })) || []
        ),
        ae_service: JSON.stringify(
          aeService.map((item, index) => ({ ...item, id: index })) || []
        ),
        financial_coresponsible:
          (values &&
            values.financial_coresponsible &&
            values.financial_coresponsible.value) ||
          values.financial_coresponsible,
        entry_checklist: values?.entry_checklist
          ? JSON.stringify(values?.entry_checklist)
          : null,
        id_consultant: consultantId,
        bodyshop_discount: values?.bodyshop_discount || 0,
        aesthetics_discount: values?.aesthetics_discount || 0,
        parts_discount: values?.parts_discount || 0,
        // Preservar dados de assinatura existentes
        ...(existingSignatureData.client_authorization !== undefined && {
          client_authorization: existingSignatureData.client_authorization,
          client_signature: existingSignatureData.client_signature,
          signature_date: existingSignatureData.signature_date,
        }),
      };

      const saveResult = await saveBudgetServiceOrder(values?.id, body);
      const { error, data } = saveResult;
      if (!error) {
        alertSuccess('Sucesso ao salvar a ordem de serviço!');
        const newServiceOrderId = data[0].id;

        // Atualizar o values com o ID da OS criada (importante para assinatura)
        setValues((prev) => ({
          ...prev,
          id: newServiceOrderId,
        }));
        setOldValues((prev) => ({
          ...prev,
          id: newServiceOrderId,
        }));

        if (newlyImportedBudgets && newlyImportedBudgets.length > 0) {
          const importedBudgetsToInsert = newlyImportedBudgets.map(
            (budget) => ({
              budget_id: budget.id,
              service_order_id: newServiceOrderId,
            })
          );

          const { error: insertError } = await supabase
            .from('ImportedBudgetOS')
            .insert(importedBudgetsToInsert);

          if (insertError) {
            console.error('Erro ao salvar orçamentos importados:', insertError);
            alertError('Erro ao salvar referência dos orçamentos importados.');
          }
        }

        // Só redireciona se não for para pular o redirect (caso da assinatura)
        if (!skipRedirect) {
          history.push(`/order-services/details/${newServiceOrderId}`);
        }
        dispatch(setData({ reloadBudget: !reloadBudget }));

        if (functionPrint) {
          functionPrint(); // check this l8r
        }

        // Retorna o ID da OS salva
        return newServiceOrderId;
      } else {
        alertError(
          'Erro ao salvar a ordem de serviço, tente novamente mais tarde.'
        );
        return null;
      }
    } catch (error) {
      alertError(
        'Erro ao salvar a ordem de serviço, tente novamente mais tarde.'
      );
      return null;
    }

    // Criar payment se for novo (value = '0' ou string) antes de salvar a ordem de serviço
    if (
      values?.payment &&
      (values.payment.value === '0' ||
        values.payment.value === 0 ||
        (typeof values.payment === 'object' &&
          typeof values.payment.value === 'string' &&
          values.payment.value === '0'))
    ) {
      try {
        const savePayment = await savePaymentTypes({
          id_company: company.id,
          payment_type: values.payment,
        });

        const { error, data } = savePayment;
        if (!error && data?.[0]) {
          alertSuccess('Sucesso ao salvar a opção de pagamento!');
          dispatch(setData({ reloadPaymentOptions: !reloadPaymentOptions }));
          // Atualizar o values para usar o ID real do payment criado
          setValues((prev) => ({
            ...prev,
            payment: { label: values.payment.label, value: data[0].id }
          }));
        } else {
          alertError(
            'Erro ao salvar a opção de pagamento, tente novamente mais tarde.'
          );
        }
      } catch (error) {
        alertError(
          'Erro ao salvar a opção de pagamento, tente novamente mais tarde.'
        );
      }
    }
    // Criar TypeOS se for novo (value = '0' ou string) antes de salvar a ordem de serviço
    if (
      values?.os_type &&
      (values.os_type.value === '0' ||
        values.os_type.value === 0 ||
        (typeof values.os_type === 'object' &&
          typeof values.os_type.value === 'string' &&
          values.os_type.value === '0'))
    ) {
      try {
        const saveTypeOSData = await saveTypeOS({
          id_company: company.id,
          os_type: values.os_type,
        });

        const { error, data } = saveTypeOSData;
        if (!error && data?.[0]) {
          alertSuccess('Sucesso ao salvar o tipo da OS!');
          setReloadTypeOS((prev) => !prev);
          // Atualizar o values para usar o ID real do TypeOS criado
          setValues((prev) => ({
            ...prev,
            os_type: { label: values.os_type.label, value: data[0].id }
          }));
        } else {
          alertError(
            'Erro ao salvar o tipo da OS, tente novamente mais tarde.'
          );
        }
      } catch (error) {
        alertError('Erro ao salvar o tipo da OS, tente novamente mais tarde.');
      }
    }
  };

  const onChange = (field, value) => {
    setReloadPrint((reload) => !reload);
    setValues((values) => ({ ...values, [field]: value }));
  };

  const onRemove = async () => {
    // Só permite excluir a OS depois de excluir a cobrança no financeiro. A
    // cobrança com parcela paga não pode ser excluída (regra B), então a OS paga
    // fica protegida por consequência.
    if (values?.id) {
      const charges = await loadFinancialEntriesByOS(values.id);
      if (charges.length > 0) {
        const total = charges.reduce(
          (sum, e) => sum + (Number(e.total_value) || 0),
          0
        );
        await Swal.fire({
          title: 'Cobrança vinculada',
          html: `Esta OS tem uma cobrança no financeiro (total ${formatCurrency(
            total
          )}). Exclua a cobrança na Dashboard Financeira antes de excluir a OS.`,
          icon: 'info',
          confirmButtonText: 'Entendi',
        });
        return;
      }
    }

    const confirmation = await Swal.fire({
      title: 'Deseja mesmo excluir?',
      showCancelButton: true,
      showConfirmButton: false,
      showDenyButton: true,
      icon: 'warning',
      text: 'Seus dados serão completamente perdidos!',
      denyButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
    });

    if (confirmation.isDenied) {
      if (values && values.id) {
        // First, delete imported budget references
        const { error: importedBudgetError } = await supabase
          .from('ImportedBudgetOS')
          .delete()
          .eq('service_order_id', values.id);

        if (importedBudgetError) {
          console.error('Erro ao remover orçamentos importados:', importedBudgetError);
        }

        // Then delete the service order
        const { data, error } = await deletedBudgetServiceOrder(
          values.id,
          user.id
        );

        if (!error) {
          alertSuccess('Orçamento removido com sucesso!');
          history.push('/order-services');
          dispatch(setData({ reloadBudget: !reloadBudget }));
        } else {
          alertError('Erro ao remover o cliente, tente novamente mais tarde');
        }
      } else {
        alertError('Erro ao remover o cliente, tente novamente mais tarde');
      }
    } else {
      history.push('/order-services');
    }
  };

  const onRemovePiece = (data) => {
    setReloadPrint((reload) => !reload);
    setParts((oldParts) => oldParts.filter((part) => part.id !== data.id));
  };
  const onRemoveService = (data) => {
    setReloadPrint((reload) => !reload);
    setBodyshopService((oldServices) =>
      oldServices.filter((service) => service.id !== data.id)
    );
  };
  const onRemoveAeService = (data) => {
    setReloadPrint((reload) => !reload);
    setAeService((oldAeServices) =>
      oldAeServices.filter((aeService) => aeService.id !== data.id)
    );
  };

  const sendWhatsapp = async () => {
    const clientId = values?.client?.value || values?.client;
    const clientName = values?.client?.label || values?.client_name;
    const clientVehicle = values?.Vehicle?.model;
    const matchingClient = client.find((item) => item.value === clientId);
    let cellphone = matchingClient?.cellphone || values?.client?.cellphone;

    if (!cellphone && clientId) {
      const { data: freshClient } = await supabase
        .from('Client')
        .select('cellphone')
        .eq('id', clientId)
        .is('deleted_at', null)
        .single();
      cellphone = freshClient?.cellphone;
    }

    if (!cellphone) {
      alertError('Cliente não possui telefone cadastrado.');
      return;
    }

    const budgetId = values.id;
    let fullUrl = externalUrl;
    if (!fullUrl) {
      const { data, error } = await issueExternalLink('os', budgetId);
      if (error || !data?.token) {
        alertError('Erro ao gerar o link da OS. Tente novamente.');
        return;
      }
      fullUrl = buildExternalUrl('os', data.token);
    }
    const message = `Olá ${clientName}, somos da empresa ${company?.tradingName}.\nSegue o link da Ordem de Serviço do seu veículo ${clientVehicle}. Acesse para visualizar os detalhes e assinar digitalmente!\n${fullUrl}`;
    const whatsappUrl = buildWaMeUrl({ phone: cellphone, message });

    // Navega ANTES dos side effects para preservar a "transient user activation"
    // — sem isso, o universal link do WhatsApp não dispara o app no mobile.
    openWhatsapp(whatsappUrl);

    if (values?.shared_at === null) {
      // shared_at é metadado interno; falha aqui não afeta o envio em si.
      saveBudgetServiceOrder(budgetId, { shared_at: new Date() }).catch(
        (err) => {
          console.warn('Falha ao registrar shared_at da OS:', err);
        }
      );
    }
  };

  const onChangePiece = (field, value) => {
    setPart((part) => ({ ...part, [field]: value }));
  };

  const openEditModal = (item) => {
    setIsOpen(5);
    setPart({
      ...item,
      profit: item?.profit ? item.profit : undefined,
      discount: item?.discount ? item.discount : undefined,
      gross_price: item?.value,
      images: item?.images?.images
        ? JSON.parse(item?.images?.images)
        : item?.images
        ? ''
        : '',
    });
  };

  return (
    <ModalBudget
      compareValues={
        isNew
          ? compareValues({ oldValues }, { values })
          : compareValues(oldValues, {
              ...values,
              parts: JSON.stringify(parts || []),
              service: JSON.stringify(bodyshopService || []),
              ae_service: JSON.stringify(aeService || []),
            })
      }
      isNewValue={compareValues(values, oldValues, {
        ...values,
        parts: JSON.stringify(parts || []),
        service: JSON.stringify(bodyshopService || []),
        ae_service: JSON.stringify(aeService || []),
      })}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      openEditModal={openEditModal}
      onChangePiece={onChangePiece}
      part={part}
      setPart={setPart}
      company={company}
      printCompany={printCompany}
      reloadPrint={reloadPrint}
      addedParts={addedParts}
      calculateTotalValue={calculateTotalValue}
      valuesBasedOnSize={valuesBasedOnSize}
      changeValue={changeValue}
      changePartsValue={changePartsValue}
      changePartsDetail={changePartsDetail}
      addedServices={addedServices}
      serviceType={serviceType}
      setServiceType={setServiceType}
      setAddBudget={setAddBudget}
      responsible={responsible}
      isntLinearHour={isntLinearHour}
      setIsntLinearHour={setIsntLinearHour}
      closeModal={closeModal}
      onChange={onChange}
      values={values}
      isNew={isNew}
      onSave={onSave}
      sendWhatsapp={sendWhatsapp}
      client={client}
      clientLoading={clientLoading}
      setClient={setClient}
      vehicle={vehicle}
      vehicleLoading={vehicleLoading}
      setVehicle={setVehicle}
      budget={budget}
      open={open}
      addBudget={addBudget}
      setOpen={setOpen}
      bodyshopService={bodyshopService}
      setBodyshopService={setBodyshopService}
      setBodyshopServiceVersion={setBodyshopServiceVersion}
      aeService={aeService}
      setAeService={setAeService}
      reload={reload}
      setReload={setReload}
      parts={parts}
      setParts={setParts}
      showBudgetItems={showBudgetItems}
      onRemove={onRemove}
      onRemovePiece={onRemovePiece}
      onRemoveService={onRemoveService}
      onRemoveAeService={onRemoveAeService}
      hvTable={hvTable}
      changeValueAeService={changeValueAeService}
      setValues={setValues}
      setSetHasCreatedConsultant={setSetHasCreatedConsultant}
      setHasCreatedTypeOS={setHasCreatedTypeOS}
      setReloadPrint={setReloadPrint}
      setOldValues={setOldValues}
      setHasCreated={setHasCreated}
      reloadConsultants={reloadConsultants}
      reloadTypeOS={reloadTypeOS}
      setClientCreationContext={setClientCreationContext}
      clientCreationContext={clientCreationContext}
    />
  );
};

export default ModalOrderServiceBudgetContainer;

const dateWithoutTimezone = (date) => {
  const tzoffset = date.getTimezoneOffset() * 60000; //offset in milliseconds
  const withoutTimezone = new Date(date.valueOf() - tzoffset)
    .toISOString()
    .slice(0, -1);
  return withoutTimezone;
};
